export const addItem = id => ({
  type: 'ADD_ITEM',
  id,
});

export const removeItem = id => ({
  type: 'REMOVE_ITEM',
  id,
});



// WEBPACK FOOTER //
// ./src/custom/Toggle/actions.js